(() => {
  const mobile = window.matchMedia('(max-width: 849px)');
  const selectors = [
    '#dummy-chat-button-iframe',
    'iframe[id*="chat" i]',
    'iframe[title*="chat" i]',
    'iframe[src*="chat" i]',
    'iframe[title*="cookie" i]',
    'iframe[src*="cookie" i]',
    '[id*="shopify-chat" i]',
    '[id*="cookie" i]',
    '[aria-label*="chat" i]',
    '[aria-label*="cookie" i]'
  ];

  let timer = 0;

  function parentAcrossShadow(node) {
    if (node.parentElement) return node.parentElement;
    const root = node.getRootNode?.();
    return root && root.host ? root.host : null;
  }

  function fixedHost(node) {
    let current = node;
    for (let i = 0; current && i < 10; i += 1) {
      if (window.getComputedStyle(current).position === 'fixed') return current;
      current = parentAcrossShadow(current);
    }
    return null;
  }

  function roots() {
    const found = [document];
    for (let index = 0; index < found.length; index += 1) {
      found[index].querySelectorAll?.('*').forEach((element) => {
        if (element.shadowRoot && !found.includes(element.shadowRoot)) found.push(element.shadowRoot);
      });
    }
    return found;
  }

  function reposition() {
    window.clearTimeout(timer);
    if (!mobile.matches || !document.querySelector('.rms-cart-mobile-checkout')) return;

    roots().forEach((root) => {
      root.querySelectorAll(selectors.join(',')).forEach((node) => {
        const host = fixedHost(node) || node;
        if (host.closest?.('.rms-cart-mobile-checkout')) return;
        const rect = host.getBoundingClientRect();
        if (rect.width > 460 || rect.height > 260) return;
        host.style.setProperty('bottom', 'calc(94px + env(safe-area-inset-bottom))', 'important');
        host.style.setProperty('z-index', '46', 'important');
        host.dataset.rmsCartOffset = 'true';
      });
    });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(reposition, 60);
  }

  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.addEventListener('load', schedule, { once: true });
  mobile.addEventListener?.('change', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  [300, 900, 1800, 3500, 7000].forEach((delay) => window.setTimeout(reposition, delay));
})();
